import api from "../../../services/api";

export const getMarketingWholesalePromo = async (
  month = "2025-04",
  limit = 40
) => {
  const response = await api.get("/api/wholesale/marketing/wholesale_promo", {
    params: { month, limit },
  });
  return response.data;
};
